import {useEffect} from 'react'
import {useState} from 'react'

const useEventInfor = (eventData) => {
	const [success, setSuccess] = useState()
	const [eventName, setEventName] = useState()
	const [logoImg, setLogoImg] = useState()
	const [prizeData, setPrizeData] = useState()
	const [infoData, setInfoData] = useState([
		{
			label: 'Players',
			data: '0',
		},
		{
			label: 'Entries',
			data: '0',
		},
		{
			label: 'Re-Entry',
			data: '0',
		},
		{
			label: 'Early',
			data: '0',
		},
		{
			label: 'Add-on',
			data: '0',
		},
		{
			label: 'Avg Stacks (BB)',
			data: '0',
		},
		{
			label: 'Total Stacks',
			data: '0',
		},
	])

	useEffect(() => {
		if (eventData) {
			const backendData = eventData?.data
			setEventName(backendData?.name)
			setLogoImg(backendData?.logo_img)
			setPrizeData({
				list: backendData?.prize_list,
				total: backendData?.prize_total,
			})
			setSuccess(true)
		}
	}, [eventData])

	return {
		eventName,
		logoImg,
		prizeData,
		infoData,
		success,
		setEventName,
		setLogoImg,
		setPrizeData,
		setInfoData,
	}
}

export default useEventInfor
